const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Εταιρικό Γραφείο",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Κτηνιατρική Πρακτική",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Υποχρεωτικό",
    },
  },
  salutation: {
    label: "Προσφώνηση",
    placeholder: "Επιλέξτε προσφώνηση",
    errors: {
      required: "Προσφώνηση είν αι υποχρεωτικό",
      invalid: "Επιλέξτε έγκυρη προσφώνηση",
    },
  },
  firstName: {
    label: "Όνομα",
    placeholder: "Γιώργος",
    errors: {
      required: "Όνομα είν αι υποχρεωτικό",
      minLength: "Το όνομα πρέπει να είναι τουλάχιστον 2 χαρακτήρες",
      maxLength: "Το όνομα πρέπει να είναι έως 50 χαρακτήρες",
    },
  },
  lastName: {
    label: "Επώνυμο",
    placeholder: "Παπαδόπουλος",
    errors: {
      required: "Επώνυμο είν αι υποχρεωτικό",
      minLength: "Το επώνυμο πρέπει να είναι τουλάχιστον 2 χαρακτήρες",
      maxLength: "Το επώνυμο πρέπει να είναι έως 50 χαρακτήρες",
    },
  },
  email: {
    label: "Email",
    placeholder: "giorgos.papadopoulos@example.com",
    description:
      " Εισαγάγετε τη προσωπική σας διεύθυνση email, όχι κοινόχρηστη διεύθυνση email.",
    prefixWarningTitle: "Εντοπίστηκε κοινόχρηστο γραμματοκιβώτιο",
    prefixWarningDescription:
      "Συνιστούμε τη χρήση προσωπικής διεύθυνσης email για καλύτερη και πιο προσωποποιημένη εμπειρία",
    errors: {
      required: "Email είν αι υποχρεωτικό",
      invalidEmail: " Εισαγάγετε έγκυρη διεύθυνση email",
      emailAssociatedWithYourAccount:
        "Η διεύθυνση email σας συνδέεται με τον λογαριασμό σας και δεν μπορεί να αλλάξει.",
    },
  },
  confirmEmail: {
    label: "Επιβεβαίωση email",
    placeholder: "giorgos.papadopoulos@example.com",
    errors: {
      required: "Επιβεβαίωση email είν αι υποχρεωτικό",
      invalidEmail: " Εισαγάγετε έγκυρη διεύθυνση email",
      emailMatchError: "Οι διευθύνσεις email δεν ταιριάζουν",
    },
  },
  password: {
    label: "Κωδικός",
    placeholder: " Εισαγάγετε τον κωδικό σας",
    errors: {
      required: "Κωδικός είν αι υποχρεωτικό",
    },
  },
  confirmPassword: {
    label: "Επιβεβαίωση κωδικού",
    placeholder: "Επιβεβαίωση κωδικούsi",
    errors: {
      required: "Επιβεβαίωση κωδικού είν αι υποχρεωτικό",
      passwordMatchError: "Οι κωδικοί δεν ταιριάζουν",
    },
  },
  addressLine1: {
    label: "Γραμμή διεύθυνσης 1",
    placeholder: "Οδός Παραδείγματος 123",
    errors: {
      required: "Γραμμή διεύθυνσης 1 είν αι υποχρεωτικό",
      minLength:
        "Η γραμμή διεύθυνσης 1 πρέπει να είναι τουλάχιστον 5 χαρακτήρες",
      maxLength: "Η γραμμή διεύθυνσης 1 πρέπει να είναι έως 100 χαρακτήρες",
    },
  },
  addressLine2: {
    label: "Γραμμή διεύθυνσης 2",
    placeholder: "Διαμέρισμα 4B",
    errors: {
      required: "Γραμμή διεύθυνσης 2 είν αι υποχρεωτικό",
      maxLength: "Η γραμμή διεύθυνσης 2 πρέπει να είναι έως 100 χαρακτήρες",
    },
  },
  city: {
    label: "Πόλη",
    placeholder: "Αθήνα",
    errors: {
      required: "Πόλη είν αι υποχρεωτικό",
      minLength: "Πόλη on oltava τουλάχιστον 2 χαρακτήρες",
      maxLength: "Πόλη on oltava έως 50 χαρακτήρες",
    },
  },
  state: {
    label: "Περιφέρεια",
    placeholder: "Επιλέξτε περιφέρεια",
    errors: {
      required: "Περιφέρεια είν αι υποχρεωτικό",
      invalid: "Επιλέξτε έγκυρη περιφέρεια",
    },
  },
  jurisdiction: {
    label: "Δικαιοδοσία",
    placeholder: "Επιλέξτε δικαιοδοσία",
    errors: {
      required: "Δικαιοδοσία είν αι υποχρεωτικό",
      invalid: "Επιλέξτε έγκυρη δικαιοδοσία",
    },
  },
  zipCode: {
    label: "Ταχυδρομικός κώδικας",
    placeholder: "10001",
    errors: {
      required: "Ταχυδρομικός κώδικας είν αι υποχρεωτικό",
      invalid: " Εισαγάγετε έγκυρο ταχυδρομικό κώδικα",
    },
  },
  role: {
    label: "Ρόλος",
    placeholder: "Επιλέξτε τον ρόλο σας",
    errors: {
      required: "Επιλέξτε τον ρόλο σας",
      invalid: "Επιλέξτε έγκυρο ρόλο",
    },
  },
  businessType: {
    label: "Τύπος Επιχείρησης",
    placeholder: "Επιλέξτε τύπο εταιρείας",
    errors: {
      required: "Τύπος Επιχείρησης είν αι υποχρεωτικό",
      invalid: "Επιλέξτε έγκυρο τύπο εταιρείας",
    },
  },
  businessName: {
    label: "Όνομα Εταιρείας",
    placeholder: " Εισαγάγετε το όνομα της εταιρείας",
    errors: {
      required: "Όνομα Εταιρείας είν αι υποχρεωτικό",
      minLength: "Το όνομα εταιρείας πρέπει να είναι τουλάχιστον 2 χαρακτήρες",
      maxLength: "Το όνομα εταιρείας πρέπει να είναι έως 100 χαρακτήρες",
    },
  },
  businessSearch: {
    label: "Αναζήτηση Εταιρείας:",
    addNewAccount: "Προσθήκη νέου λογαριασμού εταιρείας",
    canNotFindBusiness: "Δεν βρίσκετε την εταιρεία σας;",
    guideline:
      " Εισαγάγετε τον ταχυδρομικό σας κώδικα και στη συνέχεια επιλέξτε από την παρακάτω λίστα.",
    guidelineForNameSearch:
      " Εισαγάγετε το πλήρες όνομα της εταιρείας και στη συνέχεια επιλέξτε από τη λίστα.",
    placeholder: "Πού εργάζεστε;",
    noResults: "Δεν βρέθηκαν αποτελέσματα",
    searching: "Αναζήτηση...",
    selectedBusinessHeading: "Επιλεγμένη εταιρεία:",
    selectedBusinessNotCorrect: "Δεν είναι  σωστό;",
    selectedBusinessTryAgain: "Προσπαθήστε ξανά",
    selectedBusinessDismiss: "Απόρριψη εταιρείας",
    resultsFound: {
      singular: "Βρέθηκε 1 εταιρεία",
      plural: "Βρέθηκαν πολλές εταιρείες",
    },
    errors: {
      network:
        "Υπάρχουν προβλήματα με τη σύνδεση στην υπηρεσία αναζήτησης εταιρείας. Παρακαλώ δοκιμάστε ξανά αργότερα.",
    },
  },
  explicitConsent: {
    label:
      "Επιλέγοντας αυτό το πλαίσιο, αποδέχομαι τους όρους χρήσης της Elanco και επιβεβαιώνω ότι η Elanco συλλέγει και επεξεργάζεται τα προσωπικά μου δεδομένα σύμφωνα με την πολιτική απορρήτου της Elanco",
    errors: {
      required: "Απαιτείται ρητή συγκατάθεση",
    },
  },
  telephone: {
    label: "Προσωπικό τηλέφωνο",
    placeholder: " Εισαγάγετε τον προσωπικό σας αριθμό τηλεφώνου",
    dialCodeLabel: "Κωδικός",
    dialCodePlaceholder: "Αναζήτηση χώρας...",
    errors: {
      invalid: " Εισαγάγετε έγκυρο αριθμό τηλεφώνου.",
    },
  },
  businessTelephone: {
    label: "Τηλέφωνο Εταιρείας",
    placeholder: " Εισαγάγετε τον αριθμό τηλεφώνου της εταιρεί ας",
    dialCodeLabel: "Κωδικός",
    dialCodePlaceholder: "Αναζήτηση χώρας...",
    errors: {
      invalid: " Εισαγάγετε έγκυρο αριθμό τηλεφώνου.",
    },
  },
  professionalNumber: {
    label: "Επαγγελματικός αριθμός",
    placeholder: "1234567",
    errors: {
      required: " Εισαγάγετε τον επαγγελματικό αριθμό",
      maxLength: "Η εισαγωγή υπερβαίνει το όριο χαρακτήρων",
    },
  },
  addressSearch: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  businessSearchField: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  checkbox: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  combobox: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  datePicker: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  dateRange: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  dateTime: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  emailField: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  fileInput: {
    errors: {
      required: "Επιλέξτε αρχείο",
    },
  },
  number: {
    errors: {
      required: " Εισαγάγετε αριθμό",
      minValue: " Εισαγάγετε τιμή μεγαλύτερη από την ελάχιστη τιμή",
      maxValue: " Εισαγάγετε τιμή μικρότερη από τη μέγιστη τιμή",
    },
  },
  passwordField: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  rangeSlider: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  select: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  telephoneField: {
    errors: {
      required: " Εισαγάγετε μόνο αριθμούς",
      invalidTelephone: " Εισαγάγετε έγκυρο αριθμό τηλεφώνου",
      invalidFormat: "Μη έγκυρη μορφή αριθμού",
    },
  },
  text: {
    errors: {
      required:
        "Χρησιμοποιήστε μόνο γράμματα (A-Z), αριθμούς (0-9) και χωρίς σύμβολα",
      maxLength: "Η εισαγωγή υπερβαίνει το όριο χαρακτήρων",
      minLength: "Η εισαγωγή πρέπει να είναι τουλάχιστον 2 χαρακτήρες",
    },
  },
  textarea: {
    characters: "χαρακτήρες",
  },
  time: {
    errors: {
      required: "Αυτό το πεδίο είναι υποχρεωτικό",
    },
  },
  form: {
    errors: {
      generic: "Lomakkeen lähettämisessä tapahtui virhe. Προσπαθήστε ξανά.",
      reportAnIssue: "Αναφορά προβλήματος.",
      configuration: "Σφάλμα διαμόρφωσης",
      noFormQuestionsAvailable: "Τα στοιχεία φόρμας δεν είναι διαθέσιμα.",
      formComponentLoad:
        "Δεν ήταν δυνατή η φόρτωση του στοιχείου φόρμας λόγω μη υποστηριζόμενου πεδίου.",
      code: "Κωδικός",
      type: "Tyyppi",
      missingRequiredFields:
        "Η φόρμα λείπει απαιτούμενα πεδία (Email ή/και Συγκατάθεση). Παρακαλώ επικοινωνήστε με τον διαχειριστή για να διορθώσει τη διαμόρφωση της φόρμας.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Ευημερία Ζώων - Κτηνίατρος",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Κτηνίατρος",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Κτηνίατρος", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Κτηνίατρος, ιδιοκτήτης πρακτικής",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Βοηθός κτηνιάτρου",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Κτηνιατρική Πρακτική - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Κτηνιατρική Πρακτική - Κτηνίατρος",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Κτηνιατρική Πρακτική - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Ειδικός Κτηνίατρος",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Κτηνίατρος",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Κύριος",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Κύριος",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Κυρία",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Κυρία",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Καθηγητής",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
